import { useState } from 'react';
import { useMaintenanceMode } from '../contexts/MaintenanceModeContext';

export function useMaintenanceCTA() {
  const { isMaintenanceMode } = useMaintenanceMode();
  const [isWaitlistOpen, setIsWaitlistOpen] = useState(false);

  const handleCTA = (normalAction?: () => void) => {
    if (isMaintenanceMode) {
      setIsWaitlistOpen(true);
    } else if (normalAction) {
      normalAction();
    }
  };

  return {
    isMaintenanceMode,
    isWaitlistOpen,
    setIsWaitlistOpen,
    handleCTA
  };
}
